import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  ListItem,
  ListItemText,
  ListSubheader,
  List,
  Backdrop,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogContent,
  InputLabel,
  FormControl,
  TextField,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@material-ui/core";
import moment from "moment";
import {
  AiOutlineMinusSquare,
  AiOutlinePlusSquare,
  AiTwotoneEdit,
} from "react-icons/ai";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import useStyles from "../../../themes/style.js";
import axios from "axios";
import { useNotification } from "../../../hooks/useNotification.js";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "./styled-components/CustomAccordian.js";

const PayslipDetails = ({
  userDetails,
  paymentDate,
  currentSalaryData,
  payslipData,
  onUpdate,
}) => {
  const [employeeData, setEmployeeData] = useState(null);
  const [salaryMasterData, setSalaryMasterData] = useState({});
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const handleNotificationCall = useNotification();
  const [expandedPanels, setExpandedPanels] = useState({});
  const [activeEdit, setActiveEdit] = useState(null);
  const [editSalaryFields, setEditSalaryFields] = useState(null);
  const [viewSalaryFields, setViewSalaryFields] = useState([]);
  const [loader, setLoader] = useState(false);
  const [updateNewData, setUpdateNewData] = useState(false);

  const [editingRow, setEditingRow] = useState(null);
  const [editValues, setEditValues] = useState({ amount: "", remark: "" });
  const [skipLoan, setSkipLoan] = useState(false);

  const handleEditRowClick = (row) => {
    setEditingRow(row.id);
    setEditValues({ amount: row.amount, remark: row.remark });
  };

  const handleEditRowCancel = () => {
    setEditingRow(null);
    setEditValues({ amount: "", remark: "" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditValues((prev) => ({ ...prev, [name]: value }));
  };

  const dynamicSchema = (key, label) =>
    Yup.object().shape({
      [key]: Yup.number()
        .required(`${label} is required`)
        .typeError("value must be a number"),
      remarks: Yup.string().required("Remarks are required"),
    });

  const loanSkipSchema = Yup.object().shape({
    payForLoan: Yup.boolean()
      .required("This field is required")
      .oneOf([true, false], "Invalid value for skip"),
    remarks: Yup.string().required("Remarks are required"),
  });

  const {
    register: loanSkipRegister,
    handleSubmit: loanSkipSubmit,
    control: loanSkipController,
    setValue: loanSkipSetValue,
    reset: loanSkipReset,
    formState: { errors: loanSkipErrors },
  } = useForm({
    resolver: yupResolver(loanSkipSchema),
    payForLoan: false,
    remarks: "",
  });

  const schema = dynamicSchema(editSalaryFields?.key, editSalaryFields?.title);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    [editSalaryFields?.key]: editSalaryFields?.amount || 0,
    remarks: "",
  });

  const handleMasterSalaryDetailsEdit = async (data) => {
    setLoader(true);
    const bodyData = {
      id: salaryMasterData?.id,
      [editSalaryFields.key]: data[editSalaryFields.key],
      remarks: {
        [editSalaryFields.key]: data["remarks"],
      },
      monthIndex: new Date(paymentDate).getMonth(),
      year: new Date(paymentDate).getFullYear(),
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/masterSalaryDetailsEdit`,
        bodyData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        // fetchDeparmentsData();
        onUpdate();
        handleCloseModal();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
    // setEditSalaryFields(null);
  };
  const handlePayslipEditValues = async (data) => {
    setLoader(true);
    const bodyData = {
      payslipId: payslipData?.isProcessed.id,
      userId: userDetails?.id,
      [editSalaryFields.key]: data[editSalaryFields.key],
      remarks: {
        [editSalaryFields.key]: data["remarks"],
      },
      forMonth: new Date(paymentDate).getMonth(),
      forYear: new Date(paymentDate).getFullYear(),
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/payslipEditValues`,
        bodyData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        onUpdate();
        handleCloseModal();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleSkipLoanAmonth = async (values) => {
    setLoader(true);
    const bodyData = {
      payslipId: payslipData?.isProcessed.id,
      userId: userDetails?.id,
      payForLoan: values.payForLoan,
      remarks: {
        payForLoan: values.remarks,
      },
      forMonth: new Date(paymentDate).getMonth(),
      forYear: new Date(paymentDate).getFullYear(),
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/payslipEditValues`,
        bodyData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        onUpdate();
        handleCloseSkipLoanModal();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleEditRowFormSubmit = async (id) => {
    if (editValues.amount === "" || editValues.remark === "") {
      handleNotificationCall("error", "Edit Values Cannot be Empty");
      return;
    }

    setLoader(true);
    const bodyData = {
      id: id,
      amount: editValues.amount,
      remark: editValues.remark,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/editMasterSalaryHistory`,
        bodyData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        const responseData = response.data.data;
        const updateData = viewSalaryFields.filter(
          (item) => item.id !== responseData.id,
        );
        setViewSalaryFields([...updateData, responseData]);
        handleNotificationCall("success", response.data.message);
        setEditingRow(null);
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const fetchSalaryMasterHistory = async (item, type) => {
    setLoader(true);
    const bodyData = {
      userId: userDetails?.id,
      keyType: item.key,
      salaryDetailId: salaryMasterData?.id,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/viewMasterSalaryHistory`,
        bodyData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        const responseData = response.data.data;
        setViewSalaryFields(responseData);
        console.table(responseData);
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const fetchSalaryPayslipHistory = async (item, type) => {
    setLoader(true);

    const bodyData = {
      userId: userDetails?.id,
      keyType: item.key,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/viewPayslipHistory`,
        bodyData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        const responseData = response.data.data;
        setViewSalaryFields(responseData);
        console.table(responseData);
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (editSalaryFields?.key) {
      setValue(editSalaryFields.key, editSalaryFields.amount || 0);
      setValue("remarks", editSalaryFields.remarks || "");
    }
  }, [editSalaryFields, setValue]);

  useEffect(() => {
    if (userDetails && payslipData) {
      const employee = userDetails?.employee
        ? userDetails?.employee
        : userDetails.recruiter;
      setSalaryMasterData(userDetails.salary_detail);
      if (employee) {
        setEmployeeData(employee);
      }
    }
  }, [userDetails, payslipData]);

  function formatToINR(amount) {
    return new Intl.NumberFormat("en-IN", {
      currency: "INR",
    }).format(Math.round(amount).toFixed(2));
  }

  const totalDays = moment(paymentDate, "YYYY-M").daysInMonth();
  const effective_working_day = totalDays - currentSalaryData.lossOfPayDays;
  const totalDeductions =
    currentSalaryData?.employeePF +
    currentSalaryData?.employeeESI +
    currentSalaryData?.professionalTax;

  const netSalary = Math.round(
    currentSalaryData?.totalGrossSalary - totalDeductions,
  );

  const accordionData = [
    {
      id: "panel-1",
      title: "NET PAY",
      amount: Number(netSalary),
      children: [
        {
          id: "panel-11",
          title: "Gross",
          amount: payslipData.totalGross,
          children: [
            {
              id: "panel-111",
              title: "BASIC",
              edit: false,
              amount: payslipData?.grossValues.basicSalary,
              children: [],
            },
            {
              id: "panel-112",
              title: "HRA",
              edit: false,
              amount: payslipData.grossValues.hra,
              children: [],
            },
            {
              id: "panel-113",
              title: "CONVEYANCE",
              edit: false,
              amount: payslipData.grossValues.conveyance,
              children: [],
            },
            {
              id: "panel-114",
              title: "MEDICAL ALLOWANCE",
              edit: false,
              amount: payslipData.grossValues.medicalAllowance,
              children: [],
            },
            {
              id: "panel-115",
              title: "OTHER ALLOWANCE",
              edit: false,
              amount: payslipData.grossValues.otherAllowance,
              children: [],
            },
            {
              id: "panel-116",
              title: "BASIC ARREARS",
              key: "basicAllowanceArrears",
              edit: true,
              amount: payslipData.earningValues.basicAllowanceArrears,
              children: [],
            },
            {
              id: "panel-117",
              title: "HRA ARREARS",
              key: "hraArrears",
              edit: true,
              amount: payslipData.earningValues.hraArrears,
              children: [],
            },
            {
              id: "panel-118",
              title: "TELEPHONE ALLOWANCE ARREAR",
              key: "telephoneAllowanceArrear",
              edit: true,
              amount: payslipData.earningValues.telephoneAllowanceArrear,
              children: [],
            },
            {
              id: "panel-119",
              title: "CONVEYANCE ARREARS",
              key: "conveyanceArrears",
              edit: true,
              amount: payslipData.earningValues.conveyanceArrears,
              children: [],
            },
            {
              id: "panel-120",
              title: "MEDICAL ALLOWANCE ARREAR",
              key: "medicalAllowanceArrear",
              edit: true,
              amount: payslipData.earningValues.medicalAllowanceArrear,
              children: [],
            },
            {
              id: "panel-121",
              title: "OTHER ALLOWANCE ARREAR",
              key: "otherAllowanceArrear",
              edit: true,
              amount: payslipData.earningValues.otherAllowanceArrear,
              children: [],
            },
            {
              id: "panel-122",
              title: "BONUS",
              key: "bonus",
              edit: true,
              amount: payslipData.earningValues.bonus,
              children: [],
            },
            {
              id: "panel-123",
              title: "INCENTIVES",
              key: "incentives",
              edit: true,
              amount: payslipData.earningValues.incentives,
              children: [],
            },
            {
              id: "panel-124",
              title: "OTHER EARNINGS",
              key: "otherEarnings",
              edit: true,
              amount: payslipData.earningValues.otherEarnings,
              children: [],
            },
            {
              id: "panel-125",
              title: "REFUND FOR LAST MONTH DEDUCTION",
              key: "refundForLastMonthDeduction",
              edit: true,
              amount: payslipData.earningValues.refundForLastMonthDeduction,
              children: [],
            },

            {
              id: "panel-126",
              title: "ARREARS",
              key: "arrears",
              edit: true,
              amount: payslipData.earningValues.arrears,
              children: [],
            },
            {
              id: "panel-127",
              title: "CONSULTANT",
              edit: false,
              amount: payslipData.grossValues.consultant,
              children: [],
            },
            {
              id: "panel-128",
              title: "CONSULTANT ARREARS",
              key: "consultantArrears",
              edit: true,
              amount: payslipData.earningValues.consultantArrears,
              children: [],
            },
            {
              id: "panel-129",
              title: "MONTHLY PERFORMANCE ALLOWANCE",
              key: "consultantArrears",
              edit: true,
              amount: payslipData.earningValues.monthlyPerformanceArrears,
              children: [],
            },
            {
              id: "panel-130",
              title: "STATUTORY BONUS",
              edit: false,
              amount: payslipData.grossValues.statutoryBonus,
              children: [],
            },
            {
              id: "panel-131",
              title: "STATUTORY BONUS ARREARS",
              key: "statutoryBonusArrears",
              edit: true,
              amount: payslipData.earningValues.statutoryBonusArrears,
              children: [],
            },
            {
              id: "panel-132",
              title: "ROLE PERFORMANCE BONUS",
              key: "rolePerformanceBonus",
              edit: true,
              amount: payslipData.earningValues.rolePerformanceBonus,
              children: [],
            },
            {
              id: "panel-133",
              title: "SHIFT ALLOWANCE",
              edit: false,
              amount: payslipData.grossValues.shiftAllowance,
              children: [],
            },
            {
              id: "panel-134",
              title: "SHIFT ALLOWANCE ARREAR",
              key: "shiftAllowanceArrears",
              edit: true,
              amount: payslipData.earningValues.shiftAllowanceArrears,
              children: [],
            },
          ],
        },
        {
          id: "panel-22",
          title: "Total Deductions",
          amount: payslipData.totalDeduction,
          children: [
            {
              id: "panel-221",
              title: "PF",
              edit: false,
              amount: payslipData.deductionValues.pf,
              children: [],
            },
            {
              id: "panel-222",
              title: "ESI",
              edit: false,
              amount: payslipData.deductionValues.esi,
              children: [],
            },
            {
              id: "panel-223",
              title: "INCOME TAX",
              edit: false,
              amount: payslipData.deductionValues.incomeTax,
              children: [],
            },
            {
              id: "panel-224",
              title: "PROF TAX",
              edit: false,
              amount: payslipData.deductionValues.professionalTax,
              children: [],
            },
            {
              id: "panel-225",
              title: "LOAN",
              edit: false,
              amount: payslipData.deductionValues.loan,
              children: [],
            },
            {
              id: "panel-226",
              title: "LABOUR WELFARE FUND",
              edit: false,
              amount: payslipData.deductionValues.labourWelfareFund,
              children: [],
            },
            {
              id: "panel-227",
              title: "OTHER DEDUCTION",
              key: "otherDeduction",
              edit: true,
              amount: payslipData.deductionValues.otherDeduction,
              children: [],
            },
            {
              id: "panel-228",
              title: "NOTICE PERIOD DEDUCTION",
              key: "noticePeriodDeduction",
              edit: true,
              amount: payslipData.deductionValues.noticePeriodDeduction,
              children: [],
            },
            {
              id: "panel-229",
              title: "SPECIAL PURPOSE DEDUCTION",
              key: "specialPurposeDeduction",
              edit: true,
              amount: payslipData.deductionValues.specialPurposeDeduction,
              children: [],
            },
            {
              id: "panel-230",
              title: "STANDARD DEDUCTION",
              key: "standardDeduction",
              edit: true,
              amount: payslipData.deductionValues.standardDeduction,
              children: [],
            },
          ],
        },
        {
          id: "panel-33",
          title: "Salary Master",
          amount: payslipData.totalMaster,
          children: [
            {
              id: "panel-331",
              title: "FULL BASIC",
              key: "basicSalary",
              masterEdit: true,
              amount: payslipData.masterValues.basicSalary,
              children: [],
            },
            {
              id: "panel-332",
              title: "FULL HRA",
              key: "hra",
              masterEdit: true,
              amount: payslipData.masterValues.hra,
              children: [],
            },
            {
              id: "panel-333",
              title: "FULL TELEPHONE ALLOWANCE",
              masterEdit: true,
              key: "telephoneAllowance",
              amount: payslipData.masterValues.telephoneAllowance,
              children: [],
            },
            {
              id: "panel-334",
              title: "FULL CONVEYANCE",
              masterEdit: true,
              key: "conveyance",
              amount: payslipData.masterValues.conveyance,
              children: [],
            },
            {
              id: "panel-335",
              title: "FULL MEDICAL ALLOWANCE",
              masterEdit: true,
              key: "medicalAllowance",
              amount: payslipData.masterValues.medicalAllowance,
              children: [],
            },
            {
              id: "panel-336",
              title: "FULL SPECIAL ALLOWANCE",
              masterEdit: true,
              key: "specialAllowance",
              amount: payslipData.masterValues.specialAllowance,
              children: [],
            },
            {
              id: "panel-337",
              title: "FULL CONSULTANT",
              masterEdit: true,
              key: "consultant",
              amount: payslipData.masterValues.consultant,
              children: [],
            },
            {
              id: "panel-338",
              title: "FULL STATUTORY BONUS",
              masterEdit: true,
              key: "statutoryBonus",
              amount: payslipData.masterValues.statutoryBonus,
              children: [],
            },
            {
              id: "panel-339",
              title: "STATUTORY APPLICABILITY",
              masterEdit: true,
              key: "statutoryApplicability",
              amount: payslipData.masterValues.statutoryApplicability,
              children: [],
            },
            {
              id: "panel-340",
              title: "FULL SHIFT ALLOWANCE",
              masterEdit: true,
              key: "shiftAllowance",
              amount: payslipData.masterValues.shiftAllowance,
              children: [],
            },
          ],
        },
      ],
    },
    {
      id: "panel-2",
      title: "EMPLOYEE WORKDAYS",
      amount: effective_working_day,
      children: [
        {
          id: "panel-2-11",
          title: "EMP EFFECTIVE WORKDAYS",
          amount: effective_working_day,
          children: [],
        },
        {
          id: "panel-2-22",
          title: "EMP EFFECTIVE WORKDAYS FOR DISPLAY",
          amount: effective_working_day,
          children: [],
        },
        {
          id: "panel-2-33",
          title: "EMPLOYEE WORKDAYS FOR DISPLAY",
          amount: effective_working_day,
          children: [],
        },
        {
          id: "panel-2-44",
          title: "DAYS IN MONTH",
          amount: totalDays,
          children: [],
        },
        {
          id: "panel-2-55",
          title: "EMPLOYEE WORKDAYS",
          amount: effective_working_day,
          children: [],
        },
        {
          id: "panel-2-66",
          title: "LOP",
          amount: currentSalaryData.lossOfPayDays,
          children: [],
        },
      ],
    },
  ];

  const handleMasterDetailsEditClick = (item) => {
    setActiveEdit(item.id);
    setEditSalaryFields(item);
    fetchSalaryMasterHistory(item);
  };

  const handleGrossDetailsEditClick = (item) => {
    setActiveEdit(item.id);
    setEditSalaryFields(item);
    fetchSalaryPayslipHistory(item);
  };

  const handleCloseModal = () => {
    setActiveEdit(null);
    setUpdateNewData(false);
    reset();
  };

  const handleCloseSkipLoanModal = () => {
    setSkipLoan(false);
    loanSkipReset();
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpandedPanels((prev) => ({
      ...prev,
      [panel]: newExpanded, // Update the state for the specific panel
    }));
  };

  const dateOfBirth = moment(employeeData?.dob).format("DD MMM YYYY");
  const age = moment().diff(employeeData?.dob, "years");

  const renderAccordionsMaster = (items) => {
    return items.map((item) => {
      const isExpanded = !!expandedPanels[item.id];
      return (
        <Accordion
          key={item.id}
          square
          expanded={!!expandedPanels[item.id]}
          onChange={handleChange(item.id)}
          className={
            isExpanded
              ? "payslip-accordian-summary-base"
              : "payslip-accordian-summary-expanded"
          }
        >
          <AccordionSummary
            aria-controls={`${item.id}-content`}
            id={`${item.id}-header`}
          >
            <Box display="flex" justifyContent="space-between" width="100%">
              <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                {isExpanded ? (
                  <AiOutlineMinusSquare size={20} />
                ) : (
                  <AiOutlinePlusSquare size={20} />
                )}
                <Box sx={{ display: "flex", alignItems: "center", pl: 1 }}>
                  <Typography>{item.title}</Typography>
                </Box>
              </Box>
              <Typography>{formatToINR(item?.amount)}</Typography>
            </Box>
          </AccordionSummary>
          {item.children && item.children.length > 0
            ? renderAccordionsChild(item.children) // Recursively render nested accordions
            : item.content && <Typography>{item.content}</Typography>}
        </Accordion>
      );
    });
  };
  const renderAccordionsChild = (items) => {
    return items.map((item) => {
      const isExpanded = !!expandedPanels[item.id];
      return (
        <AccordionDetails
          style={{ padding: 0 }}
          key={`${item.id}-child-details`}
        >
          <Accordion
            key={`${item.id}-child`}
            square
            expanded={!!expandedPanels[item.id]}
            onChange={handleChange(item.id)}
            style={{ width: "100%" }}
            className={
              isExpanded
                ? "payslip-accordian-summary-base"
                : "payslip-accordian-summary-expanded"
            }
          >
            <AccordionSummary
              aria-controls={`${item.id}-content`}
              id={`${item.id}-header`}
            >
              <Box
                ml={2}
                display="flex"
                justifyContent="space-between"
                width="100%"
              >
                <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                  {item.children &&
                    item.children.length > 0 &&
                    (isExpanded ? (
                      <AiOutlineMinusSquare size={20} />
                    ) : (
                      <AiOutlinePlusSquare size={20} />
                    ))}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      pl: item.children && item.children.length > 0 ? 1 : 3,
                    }}
                  >
                    <Typography>{item.title}</Typography>
                    {payslipData?.isProcessed.status && item.edit && (
                      <Box
                        ml={1}
                        sx={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent triggering accordion expand
                          handleGrossDetailsEditClick(item);
                        }}
                      >
                        <AiTwotoneEdit size={20} color="064be2" />
                      </Box>
                    )}
                    {item.masterEdit && (
                      <Box
                        ml={1}
                        sx={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent triggering accordion expand
                          handleMasterDetailsEditClick(item);
                        }}
                      >
                        <AiTwotoneEdit size={20} color="064be2" />
                      </Box>
                    )}
                    {payslipData?.isProcessed.status && item.title === "LOAN" && (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                          loanSkipSetValue("payForLoan", false),
                            setSkipLoan(true);
                        }}
                        style={{ marginLeft: "1rem" }}
                      >
                        Skip Loan
                      </Button>
                    )}
                  </Box>
                </Box>
                <Typography>{formatToINR(item?.amount)}</Typography>
              </Box>
            </AccordionSummary>
            {item.children && item.children.length > 0
              ? renderAccordionsChild(item.children)
              : item.content && <Typography>{item.content}</Typography>}
          </Accordion>
        </AccordionDetails>
      );
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={9}>
        {renderAccordionsMaster(accordionData)}
      </Grid>
      <Grid item xs={12} lg={3}>
        <Box p={2} bgcolor="#e7eaf9">
          <Box bgcolor="#fff" borderRadius={8}>
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              subheader={
                <ListSubheader
                  component="div"
                  id="nested-list-subheader"
                  style={{ zIndex: 0 }}
                >
                  Details
                </ListSubheader>
              }
            >
              <ListItem button>
                <ListItemText
                  primary="Join Date"
                  secondary={moment(employeeData?.joinningDate).format(
                    "DD-MM-yyyy",
                  )}
                />
              </ListItem>
              <ListItem button>
                <ListItemText
                  primary="Date Of Birth"
                  secondary={`${dateOfBirth} (${age} years)`}
                />
              </ListItem>
              <ListItem button>
                <ListItemText
                  primary="Location"
                  secondary={employeeData?.companyBranchName}
                />
              </ListItem>
            </List>
          </Box>
        </Box>
      </Grid>

      <Dialog
        open={!!activeEdit}
        BackdropComponent={Backdrop}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
        onClose={handleCloseModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <h5 className="form-title">
            Edit:{" "}
            <span style={{ fontSize: "1rem" }}>
              {editSalaryFields && editSalaryFields?.title}
            </span>
          </h5>
          <Box display="flex" width="100%" mb={2}>
            {!updateNewData ? (
              <Box display="flex" justifyContent="end" width="100%">
                <Typography
                  onClick={() => {
                    setUpdateNewData(true);
                  }}
                  style={{ color: "blue", fontSize: "16px", cursor: "pointer" }}
                >
                  + Add New
                </Typography>
              </Box>
            ) : (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
              >
                <Typography variant="caption">
                  Changes Apply From:{" "}
                  {moment(paymentDate).startOf("month").format("DD MMM YYYY")}
                </Typography>
                <Typography
                  onClick={() => {
                    setUpdateNewData(false);
                  }}
                  style={{ color: "red", fontSize: "16px", cursor: "pointer" }}
                >
                  X Cancel
                </Typography>
              </Box>
            )}
          </Box>
          <Box>
            {!updateNewData ? (
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">From Date </TableCell>
                      <TableCell align="left">Amount</TableCell>
                      <TableCell align="left">Remarks</TableCell>
                      <TableCell align="left">Modified On</TableCell>
                      <TableCell align="right">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {viewSalaryFields.map((item) => (
                      <TableRow style={{ background: "#fff" }} key={item.id}>
                        <TableCell align="left">
                          {moment(item.fromDate).format("DD MMM YYYY")}
                        </TableCell>
                        <TableCell align="left">
                          {editingRow === item.id ? (
                            <TextField
                              name="amount"
                              value={editValues.amount}
                              onChange={handleInputChange}
                              size="small"
                            />
                          ) : (
                            item.amount
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {editingRow === item.id ? (
                            <TextField
                              name="remark"
                              value={editValues.remark}
                              onChange={handleInputChange}
                              size="small"
                            />
                          ) : (
                            item.remark
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {moment(item.updatedAt).format("DD MMM YYYY")}
                        </TableCell>
                        <TableCell align="right">
                          {editingRow === item.id ? (
                            <Box display="flex" gridGap={6}>
                              <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  handleEditRowFormSubmit(item.id);
                                }}
                              >
                                Save
                              </Button>
                              <Button
                                size="small"
                                onClick={handleEditRowCancel}
                              >
                                Cancel
                              </Button>
                            </Box>
                          ) : (
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() => handleEditRowClick(item)}
                            >
                              Edit
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                    {viewSalaryFields.length <= 0 && (
                      <TableCell colSpan={5} align="center">
                        No History Found Here
                      </TableCell>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <form
                onSubmit={handleSubmit(
                  editSalaryFields?.masterEdit
                    ? handleMasterSalaryDetailsEdit
                    : handlePayslipEditValues,
                )}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <InputLabel shrink htmlFor={editSalaryFields?.key}>
                      {editSalaryFields?.title}
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{
                          disableUnderline: true,
                          inputProps: { min: 0, inputMode: "numeric" },
                        }}
                        placeholder={`Enter ${editSalaryFields?.title}`}
                        name={editSalaryFields?.key}
                        {...register(editSalaryFields?.key)}
                        defaultValue={editSalaryFields?.amount}
                        error={!!errors[editSalaryFields?.key]}
                      />

                      <Typography variant="inherit" color="error">
                        {errors[editSalaryFields?.key]?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel shrink htmlFor="remarks">
                      Remarks
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Remarks"
                        name="remarks"
                        {...register("remarks")}
                        error={errors.remarks ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.remarks?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                </Grid>
                <Box my={2} display="flex" justifyContent="end" gridGap={8}>
                  <Button
                    variant="outlined"
                    color="default"
                    size="small"
                    onClick={handleCloseModal}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    type="submit"
                  >
                    Save
                  </Button>
                </Box>
              </form>
            )}
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={skipLoan}
        BackdropComponent={Backdrop}
        maxWidth="xs"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
        onClose={handleCloseSkipLoanModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <h5 className="form-title">Edit: LOAN</h5>
          <Box display="flex" width="100%" mb={2}>
            <form onSubmit={loanSkipSubmit(handleSkipLoanAmonth)}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl
                    className={classes.margin}
                    style={{ marginTop: "10px" }}
                  >
                    <Typography variant="body1">
                      Are you sure you want to skip a month of paying this loan?
                    </Typography>
                    <Controller
                      name="payForLoan"
                      control={loanSkipController}
                      render={({ field: { onChange, value } }) => (
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value === false}
                                onChange={() => onChange(false)}
                              />
                            }
                            label="Skip a month"
                          />
                        </FormGroup>
                      )}
                    />
                    <Typography variant="inherit" color="error">
                      {loanSkipErrors.payForLoan?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="remarks">
                    Remarks
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Remarks"
                      name="remarks"
                      {...loanSkipRegister("remarks")}
                      error={loanSkipErrors.remarks ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {loanSkipErrors.remarks?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="end" gridGap={8}>
                    <Button
                      variant="outlined"
                      color="default"
                      size="small"
                      onClick={handleCloseSkipLoanModal}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      type="submit"
                    >
                      Save
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </Box>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Grid>
  );
};

export default PayslipDetails;
